import { lazy } from 'react'

const RETRY_KEY = 'bonurba_chunk_retry'

/**
 * Détecte si une erreur est liée au chargement d'un chunk Vite.
 */
export function isChunkLoadError(error) {
  if (!error) return false
  const msg = error.message || ''
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    error.name === 'ChunkLoadError'
  )
}

/**
 * Wrapper autour de React.lazy qui recharge la page automatiquement
 * en cas d'erreur de chargement de chunk (déploiement récent).
 * Si la page a déjà été rechargée (sessionStorage flag), rejette
 * l'erreur pour la laisser remonter au ChunkErrorBoundary.
 */
export default function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (!isChunkLoadError(error)) {
        throw error
      }

      const alreadyRetried = sessionStorage.getItem(RETRY_KEY)
      if (alreadyRetried) {
        sessionStorage.removeItem(RETRY_KEY)
        throw error
      }

      sessionStorage.setItem(RETRY_KEY, '1')
      window.location.reload()
      return new Promise(() => {})
    })
  )
}
